import { Injectable } from '@angular/core';
import { AppAPIConfig } from './app-api-config';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class MydiaryService {
  appApi = new AppAPIConfig();
  httpOptions = {};
  httpOptionsForExportToExcel = {};
  // httpOptions = {
  //     headers: new HttpHeaders({Authorization : localStorage.getItem('token')})
  // };
  //userId = localStorage.getItem('userid');
  //uid = localStorage.getItem('id');

  constructor(private http: HttpClient) {
    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      // observe: 'response'
    };

    this.httpOptionsForExportToExcel = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      responseType: 'blob'
    };
  }

  refreshHttpOptions() {
    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      // observe: 'response'
    };
  }

  getClients() {
    return this.http.get(this.appApi.getClientsAPI, this.httpOptions);
  }

  getLocations() {
    return this.http.get(this.appApi.getLocationsAPI, this.httpOptions);
  }

  getAssignments() {
    return this.http.get(this.appApi.getAssignmentsAPI, this.httpOptions);
  }

  getTasks() {
    return this.http.get(this.appApi.getTasksAPI, this.httpOptions);
  }

  getDiary() {
    return this.http.get(
      this.appApi.getDiaryAPI + '/' + localStorage.getItem('userid'),
      this.httpOptions
    );
  }

  saveDiary(body) {
    console.log(body);
    return this.http.post<any>(this.appApi.diaryAPI, body, this.httpOptions);
  }

  viewDiary(id) {
    return this.http.get<any>(
      this.appApi.diaryAPI + '/' + id,
      this.httpOptions
    );
  }

  updateDiary(id, body) {
    console.log(body);
    return this.http.put<any>(
      this.appApi.diaryAPI + '/' + id,
      body,
      this.httpOptions
    );
  }

  deleteDiary(id) {
    return this.http.delete<any>(
      this.appApi.diaryAPI + '/' + id,
      this.httpOptions
    );
  }

  // ---
  getWeeksForFY(id) {
    return this.http.get<any>(
      this.appApi.weeksForFyAPI + '/' + id,
      this.httpOptions
    );
  }


  deleteWeekStatus(diaryDate){
    return this.http.delete<any>(
      this.appApi.deleteDiaryStatus + '/' + diaryDate,
      this.httpOptions
    );
  }

  getBranchHolidayExist(branchId, diaryDate) {
    return this.http.get(
      this.appApi.branchAPI + '/checkholiday/' + branchId + '/' + diaryDate,
      this.httpOptions
    );
  }

  getApprovers() {
    return this.http.get(this.appApi.approversAPI, this.httpOptions);
  }

  getDiaryClients() {
    return this.http.get(this.appApi.diaryClientAPI, this.httpOptions);
  }

  getClientAssignmentsMyDiary(cilentId) {
    return this.http.get(
      this.appApi.clientAPI + '/' + cilentId + '/assignments',
      this.httpOptions
    );
  }

  getClientAssignments(cilentId, partnerId,fyId) {
    return this.http.get(
      this.appApi.clientAPI + '/' + cilentId + '/' + partnerId + '/'+fyId+'/assignments',
      this.httpOptions
    );
  }

  getClientBudgetedAssignments(clientId) {
    return this.http.get(
      this.appApi.budgetAPI + '/assignment/' + clientId,
      this.httpOptions
    );
  }

  getFinancialYearByClientAssignments(clientId, assignmentId) {
    return this.http.get(
      this.appApi.budgetAPI +
        '/client/assignment/' +
        clientId +
        '/' +
        assignmentId,
      this.httpOptions
    );
  }

  checkBudgetExistOrNot(entryDate){
    return this.http.get(this.appApi.checkBudgetExistOrNotAPI + '/' + localStorage.getItem('id') + '/' + entryDate,this.httpOptions);
  }

  getAssignmentTasks(assignmentId) {
    return this.http.get(
      this.appApi.assignmentAPI + '/' + assignmentId + '/task',
      this.httpOptions
    );
  }

  getDiariesForWeek(startDate, endDate) {
    return this.http.get(
      this.appApi.diaryAPI +
        '/week/' +
        startDate +
        '/' +
        endDate +
        '/user/' +
        localStorage.getItem('userid'),
      this.httpOptions
    );
  }

  getLeavesForWeek(startDate, endDate) {
    return this.http.get(
      this.appApi.leaveAPI +
        '/week/' +
        startDate +
        '/' +
        endDate +
        '/user/' +
        localStorage.getItem('userid'),
      this.httpOptions
    );
  }

  getConveyanceRate() {
    return this.http.get(this.appApi.userAPI + '/conveyance', this.httpOptions);
  }

  getConveyanceRateOnDate(entryDate){
    return this.http.get(this.appApi.userAPI + '/conveyance/'+entryDate, this.httpOptions);
  }

  submitDiary(id) {
    return this.http.put<any>(
      this.appApi.submitDiaryAPI + '/' + id,
      {},
      this.httpOptions
    );
  }

  submitDiariesForWeek(startDate, endDate) {
    return this.http.put<any>(
      this.appApi.submitAllDiariesAPI + '/' + startDate + '/' + endDate,
      {},
      this.httpOptions
    );
  }

  // submitDiary(id){
  //   return this.http.put(this.appApi.submitDiaryAPI+"/"+id,this.httpOptions);
  // }

  // submitDiariesForWeek(startDate,endDate){
  //   return this.http.put(this.appApi.submitAllDiariesAPI+"/"+startDate+"/"+endDate,this.httpOptions);
  // }

  // Pending Submission
  getPendingSubmissionWeeksForFY(id) {
    console.log('inside list service id', id);
    console.log('inside list service token', this.httpOptions);

    return this.http.get<any>(
      this.appApi.pendingSumissionWeeksForFyAPI + '/' + id,
      this.httpOptions
    );
  }

  // Pending Approval
  getPendingDiaryApprovals() {
    return this.http.get<any>(
      this.appApi.pendingDiaryApprovalsAPI,
      this.httpOptions
    );
  }

  getPendingDiaryApprovalDetails(empId, startDate, endDate) {
    return this.http.get<any>(
      this.appApi.pendingDiaryApprovalsAPI +
        '/' +
        empId +
        '/' +
        startDate +
        '/' +
        endDate,
      this.httpOptions
    );
  }

  approveDiary(id) {
    return this.http.put<any>(
      this.appApi.approveDiaryAPI + '/' + id,
      {},
      this.httpOptions
    );
  }

  resendDiary(id, msg) {
    console.log('id ', id);
    console.log('msg ', msg);
    return this.http.put<any>(
      this.appApi.resendDiaryAPI + '/' + id + '?reason=' + msg,
      {},
      this.httpOptions
    );
  }

  approveAllDiary(employee) {
    return this.http.put<any>(
      this.appApi.approveDiaryAPI +
        '/' +
        employee.employeeId +
        '/' +
        employee.weekStartDate +
        '/' +
        employee.weekEndDate,
      {},
      this.httpOptions
    );
  }

  // MY LEAVES
  getLeaveSummaryForFy(id) {
    return this.http.get<any>(
      this.appApi.leaveSummaryAPI + '/' + id,
      this.httpOptions
    );
  }

  getLeaveType() {
    return this.http.get<any>(this.appApi.leaveTypeAPI, this.httpOptions);
  }

  submitLeave(body) {
    console.log(body);
    return this.http.post<any>(this.appApi.leaveAPI, body, this.httpOptions);
  }

  //
  getPendingLeaves() {
    return this.http.get<any>(this.appApi.pendingLeavesAPI, this.httpOptions);
  }

  getPendingLeaveDetail(id) {
    return this.http.get<any>(
      this.appApi.pendingLeavesAPI + '/' + id,
      this.httpOptions
    );
  }

  // getAppliedLeavesForUser(userId){
  //   return this.http.get<any>(this.appApi.appliedLeavesAPI+"/"+userId,this.httpOptions)
  // }

  getAppliedLeavesForUser(userId) {
    return this.http.get<any>(
      this.appApi.appliedLeavesAPI + '/' + userId,
      this.httpOptions
    );
  }

  getAppliedLeavesForLoggedinUser(id) {
    return this.http.get<any>(
      this.appApi.appliedLeavesForMyLeavesAPI +
        '/' +
        localStorage.getItem('id') +
        '/' +
        id,
      this.httpOptions
    );
  }

  changeLeaveStatus(id, status) {
    return this.http.put<any>(
      this.appApi.changeLeaveStatusAPI + '/' + id + '/' + status + '/Approved',
      {},
      this.httpOptions
    );
  }
  changeLeaveStatusMsg(id, status, msg) {
    return this.http.put<any>(
      this.appApi.changeLeaveStatusAPI + '/' + id + '/' + status + '/' + msg,
      {},
      this.httpOptions
    );
  }

  getBalanceLeavesOfUsers() {
    return this.http.get<any>(
      this.appApi.balanceLeaveAPI + '/' + localStorage.getItem('id'),
      this.httpOptions
    );
  }
  // getAppliedLeaveDetails(id){
  //   return this.http.get<any>(this.appApi.appliedLeavesAPI+'/'+id,this.httpOptions)
  // }

  getUnapprovedDiary() {
    return this.http.get(this.appApi.unapproveDiaryAPI, this.httpOptions);
  }

  getPendingDiaryWeeksForTeam(partnerId) {
    return this.http.get(
      this.appApi.pendingDiaryWeeksForTeamAPI + '/' + partnerId,
      this.httpOptions
    );
  }

  exportPendingDiaryWeeksForTeamToExcel(partnerId) {
    return this.http.get(
      this.appApi.exportPendingDiaryWeeksForTeamToExcelAPI + '/' + partnerId,
      this.httpOptionsForExportToExcel
    );
  }
}
